import type { BeaconPayloadV1 } from '@dicetechnology/dice-doris';

import { ErrorCodes } from '../enums';
import { DiceReceiverError } from '../errors';

type Primitive = null | undefined | string | number | boolean;

const validateType = (value: Primitive, type: 'string' | 'number' | 'boolean', key: string, isRequired: boolean = true) => {
    if (isRequired && value == null) {
        throw new DiceReceiverError(
            'Beacon error',
            `Invalid value for "${key}". This required property was not provided.`,
            ErrorCodes.INVALID_BEACON_DATA,
            'INVALID_BEACON_DATA'
        );
    }
    if (value != null && typeof value !== type) {
        throw new DiceReceiverError(
            'Beacon error',
            `Invalid type for "${key}". Expected ${type}, found ${typeof value}.`,
            ErrorCodes.INVALID_BEACON_DATA,
            'INVALID_BEACON_DATA'
        );
    }
};

export const validateBeaconPayload = (beaconPayload: BeaconPayloadV1): void => {
    const { action, video, endpoint, progress } = beaconPayload;
    validateType(action, 'number', 'action');
    validateType(video, 'number', 'video');
    validateType(endpoint, 'string', 'endpoint');
    validateType(progress, 'number', 'progress', false);
};
